import { getCompanyHubEditRoute } from '@confluence/ssr-app/entry-points/routes';

import { EditPageOrBlogV2Route } from './EditPageOrBlogV2Route';

export const CompanyHubEditRoute = getCompanyHubEditRoute(EditPageOrBlogV2Route);
